import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-500de254"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "btn-info"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "icon"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 我已阅读并同意《");
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 》 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_IdentityAlert = _resolveComponent("IdentityAlert");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "verify-box",
    style: _normalizeStyle({
      paddingTop: $data.extraPaddingTop + 'px'
    })
  }, [_createVNode(_component_van_field, {
    modelValue: $data.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.name = $event),
    label: "姓名",
    placeholder: "请输入姓名"
  }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
    modelValue: $data.id_card_number,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.id_card_number = $event),
    label: "身份证号",
    placeholder: "请输入身份证号"
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(['agreement', {
      'agree': $data.agreement_status
    }]),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.agreement && $options.agreement(...args))
  }, [_hoisted_2, _hoisted_3, _createElementVNode("span", {
    class: "link",
    onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.jumpAgreement && $options.jumpAgreement(...args), ["stop"]))
  }, "实名认证用户服务协议"), _hoisted_4], 2), _createElementVNode("div", {
    class: _normalizeClass(["btn", {
      'gray': $options.submitEnabled == false
    }]),
    onClick: _cache[4] || (_cache[4] = (...args) => $options.start && $options.start(...args))
  }, "开始身份认证", 2)])], 4), _createVNode(_component_IdentityAlert, {
    show: $data.showGuide,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.showGuide = $event),
    onGuideToVerifyAction: $options.guideAction
  }, null, 8, ["show", "onGuideToVerifyAction"])], 64);
}